/**
 * [ File :: G_ImageDeco.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageDeco.j
 * @설명 : Deco(장식) 이미지 객체
 * @진행 : 종료
 * @주의 : 장식 객체는 "obj list"에 들어가지 않습니다. (게임에 영향을 주지 않음)
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import G_ImageGrid from 'canvas/grid/dev/child/image/G_ImageGrid';

const G_ImageDeco = (function() {

	return class extends G_ImageGrid {
		constructor(obj) {
			super(obj);

			// [S] 객체 배열 삭제
			delete this.CODMOS.WORLD.LIST.obj[this._id];
		}
	}
}());
export default G_ImageDeco;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/image/G_ImageDeco.js